export default "__VITE_ASSET__CkPFJqRZ__"